export default __webpack_public_path__ + "static/media/projectadd.80950e36.jpg";